const excludedBy = (extensions) => {
  if (!extensions) {
    return null;
  }
  const excludedBy = extensions.find(
    ({ url }) =>
      url ===
      "http://optum.com/HCM/FHIRextensions/HCMBundleEntryComponent#excludedBy",
  );
  return excludedBy ? excludedBy.valueString : null;
};

const eimpLastUpdated = (extensions) => {
  if (!extensions) {
    return null;
  }
  const eimpLastUpdated = extensions.find(
    ({ url }) =>
      url ===
      "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#EIMPLastUpdated",
  );
  return eimpLastUpdated ? eimpLastUpdated.valueDateTime : null;
};

const identitySpecID = (extensions) => {
  if (!extensions) {
    return null;
  }
  const identitySpecID = extensions.find(
    ({ url }) =>
      url ===
      "http://optum.com/HCM/FHIRextensions/HCMBundleEntryComponent#identitySpecID",
  );
  return identitySpecID ? identitySpecID.valueString : null;
};

const hrnHandler = (extensions) => {
  const hrn = extensions.find(
    ({ url }) =>
      url === "http://optum.com/HCM/FHIRextensions/HCMBundleEntryComponent#hrn",
  );
  return hrn ? hrn.valueString : null;
};

const scoreHandler = (extensions) => {
  const score = extensions.find(
    ({ url }) =>
      url ===
      "http://optum.com/HCM/FHIRextensions/HCMBundleEntrySearchComponent#logScore",
  );
  return score ? score.valueDecimal : "";
};

const scoreStringHandler = (extensions) => {
  const scoreString = extensions.find(
    ({ url }) =>
      url ===
      "http://optum.com/HCM/FHIRextensions/HCMBundleEntrySearchComponent#explanation",
  );
  return scoreString ? scoreString.valueString : "";
};

export default (jsonBundle, filterById) => {
  if (jsonBundle.resourceType.toLowerCase() === "bundle") {
    if (jsonBundle.total > 1) {
      let entries = jsonBundle.entry;
      const identities = [];
      const records = [];
      if (!entries[0].resource.id) {
        entries.splice(0, 1);
      }
      entries.forEach((entry) => {
        if (entry.resource && entry.resource.link) {
          records.push({
            ...entry.resource,
            score: scoreHandler(entry.search.extension),
            scoreString: scoreStringHandler(entry.search.extension),
            excludedBy: excludedBy(entry.extension),
            eimpLastUpdated: eimpLastUpdated(entry.extension),
            identitySpecID: identitySpecID(entry.extension),
            hrn: hrnHandler(entry.extension),
          });
        } else {
          identities.push({
            ...entry.resource,
            eimpLastUpdated: eimpLastUpdated(entry.extension),
            threshold: jsonBundle.threshold ? jsonBundle.threshold : "-",
            score: scoreHandler(entry.search.extension),
            scoreString: scoreStringHandler(entry.search.extension),
            records: [],
          });
        }
      });

      const fhirRecords = identities.map((identity) => {
        for (let record of records) {
          if (record.link && record.link[0].other.reference === identity.id) {
            identity.records.push(record);
            if (record.identitySpecID && !identity.identitySpecID)
              identity.identitySpecID = record.identitySpecID;
          }
        }
        return identity;
      });

      const filteredFhirRecords = filterById
        ? fhirRecords.filter((obj) => obj.id !== filterById)
        : fhirRecords;
      return filteredFhirRecords;
    } else return [];
  } else return "Didn't receive FHIR bundle";
};

export const focusIdFhirBundle = (jsonBundle) => {
  if (jsonBundle.resourceType.toLowerCase() === "bundle") {
    if (jsonBundle.total > 1) {
      let entries = [jsonBundle.entry[0]];
      for (let i = 1; i < jsonBundle.entry.length; i++) {
        const entry = jsonBundle.entry[i];
        if (!entry.resource.link) {
          break;
        }
        entries.push(entry);
      }
      return {
        ...jsonBundle,
        entry: entries,
        total: entries.length,
      };
    }
  }
  console.error("jsonBundle is undefined");
};
